import React, { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import Icon, { type Props as IconProps } from '~/components/atom/Icon';

export type Props = IconProps & HTMLAttributes<HTMLButtonElement>;

const IconOnlyButton: React.FCC<Props> = ({ dataTestId, onClick, ...rest }) => (
  <Container data-testid={dataTestId} onClick={onClick} type="button">
    <Icon {...rest} />
  </Container>
);

const Container = styled.button<{}>(
  ({ theme }) => css`
    background-color: transparent;
    border: none;
    border-radius: ${theme.getTokens().border.radius.s};
    font-size: ${theme.fs('l')};
    cursor: pointer;
    padding: ${theme.space('xxxs')};

    display: flex;
    justify-content: center;
    align-items: center;

    transition: all 0.3s ease;

    &:hover {
      background-color: ${theme.color('tertiary', 'translucent')};
    }
  `,
);

export default IconOnlyButton;
